import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { BorrowerBaseballCardStore } from '../stores/';

export const useBorrowerBaseballCardStore = () => useContext<{
  borrowerBaseballCardStore: BorrowerBaseballCardStore
}>(StoreContext);
